import { ChangeDetectorRef, Component, ElementRef, HostListener, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, ValidationErrors, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class TouchedErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return !!(control && control.invalid && control.touched);
    }
}
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { ImgsCollection } from 'src/app/interfaces/images/imgs-collection.interface';
import { TokenAuthData } from 'src/app/interfaces/session-account/token-auth.interface';
import { UserAuthData } from 'src/app/interfaces/session-account/user-auth.interface';
import { PathsDataService } from 'src/app/services/paths-data.service';
import { PreRegisterResponseData, ReEnvioCorreoTempResponseData, RegisterData } from '../register-page/interfaces/register-data.interface';
import { SessionStorageDataService } from 'src/app/services/session-storage-data.service';
import { AuthService } from 'src/app/core/auth/auth.service';

// recursos de librerias externas
import * as CryptoJS from 'crypto-js';
import { AlertService } from 'src/app/services/alerts.service';
import { RegisterUserService } from '../register-page/services/register-user.service';
import { userDataGoogle } from 'src/app/core/auth/authData.model';
import Swal from 'sweetalert2';
import { InfoDataKeys } from 'src/app/interfaces/interface-key-captcha/info-data-keys.interface';
import { KeyRecaptchaServiceService } from 'src/app/services/key-recaptcha-service/key-recaptcha-service.service';
import { ConfigService } from 'src/app/services/config-service.service';



declare global {
    interface Window {
        google: any;
    }
}
@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {

    title = 'Login - Ayuda Catastro GA';
    matcher = new TouchedErrorStateMatcher();

    bgLogin?: string;
    focusedInput: string = '';
    password: string = '';
    showPassword: boolean = false;

    failedAttempts = 0;
    maxFailedAttempts = 3;

    form: FormGroup;
    recaptchaSiteKey: InfoDataKeys | null = null;
    recaptchaToken: string | null = null;
    recaptchaSize: any | undefined = 'normal';

    isButtonVisible: boolean = true;
    isRecaptchaVisible: boolean = true;

    constructor(
        private titleService: Title,
        private pathsDataService: PathsDataService,
        private fb: FormBuilder,
        private alertService: AlertService,
        private sessionStorageDataService: SessionStorageDataService,
        private authService: AuthService,
        private router: Router,
        private registerUserService: RegisterUserService,
        private keyRecaptchaServiceService: KeyRecaptchaServiceService,
        private cdr: ChangeDetectorRef,
        private configService: ConfigService
    ) {
        this.form = this.fb.group({
            email: ['', [Validators.required, this.customEmailValidator, Validators.minLength(6), Validators.maxLength(100)]],
            password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(245)]],
            recaptcha: [{ value: '', disabled: true }, [Validators.required]]
        });
    }

    ngOnInit() {
        this.titleService.setTitle(this.title);

        this.configService.userId$.subscribe(userId => {
            if (userId) {
                this.requestPreRegisterUserData(userId)
            } else {
                // Si no hay userId, puedes manejarlo como desees
                console.warn('No se encontró un userId válido en el token.');
            }
        });

        this.resquestPathImgs();
        this.getInfoKeyCaptchaService();
        this.setRecaptchaSize(); // Establece el tamaño inicial al cargar

        // Listener del resize para que se ajuste dinámicamente
        window.addEventListener('resize', () => {
            this.setRecaptchaSize();
        });
        // Verificar si la clave de reCAPTCHA está disponible antes de continuar
        if (!this.recaptchaSiteKey || !this.recaptchaSiteKey.site_key) {
            console.error("La clave de reCAPTCHA no está disponible.");
            return;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['recaptchaSize']) {
            this.setRecaptchaSize();
        }
    }


    handleKeyPress(event: KeyboardEvent) {
        if (event.key === 'Enter' && this.form.valid) {
        this.onSubmit(event);
        }
    }

    togglePasswordVisibility(input: string) {
        if (input === 'password') {
            this.showPassword = !this.showPassword;
        }
    }

    onFocus(input: string) {
        this.focusedInput = input;
    }

    onBlur() {
        this.focusedInput = '';
    }

    setRecaptchaSize(): void {
        const width = window.innerWidth;

        if (width < 576) {
            this.recaptchaSize = 'compact';
        } else if (width >= 576) {
            this.recaptchaSize = 'normal';
        }
    }

    // Método para cargar los scripts
    loadScript(url: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = (error) => reject(error);
            document.head.appendChild(script);
        });
    }


customEmailValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
        return null; // Campo vacío es válido (debes validar requerido aparte)
    }

    const email = control.value;

    // Parte local: permite letras, números y caracteres especiales permitidos
    // Pero no puede comenzar ni terminar con punto, ni tener puntos consecutivos
    // Dominio: permite letras, números, guiones (no al inicio/final) y puntos para subdominios
    const emailRegex = /^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~](\.?[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~])*@[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email)) {
        return { invalidEmail: true };
    }

    // Validaciones adicionales para casos específicos

    // Comprueba que no haya puntos consecutivos en la parte local
    if (/\.{2,}/.test(email.split('@')[0])) {
        return { invalidEmail: true };
    }

    // Validación contra intentos de inyección SQL
    const sqlKeywords = /\b(DROP|TABLE|SELECT|INSERT|DELETE|UPDATE|WHERE|EXEC|UNION|ALTER|CREATE|SCRIPT)\b/i;
    if (sqlKeywords.test(email)) {
        return { sqlInjection: true };
    }

    // Validación del largo máximo (RFC 5321)
    if (email.length > 254) {
        return { emailTooLong: true };
    }

    // Validación de la parte local no exceda 64 caracteres (RFC 5321)
    if (email.split('@')[0].length > 64) {
        return { localPartTooLong: true };
    }

    return null; // Todo válido
}

    resquestPathImgs() {
        this.pathsDataService.getPathImgs()
        .subscribe({
            next: (data: ImgsCollection) => {
                this.bgLogin = data.login_register.bgLogin;
            },
            error: (error) => {
                console.error(error);
            }
        });
    }

    // Esta función se ejecuta cuando reCAPTCHA se completa
    onRecaptchaResolved(token: string | null) {
        if (token) {
            this.recaptchaToken = token; // Guardar el token
            this.form.patchValue({ recaptcha: token });
        } else {
            console.error('Error: No se generó un token de reCAPTCHA.');
        }
        this.cdr.detectChanges();
    }


    corregirCodificacion(text: string): string {
        try {
            // Primero intentamos decodificar como UTF-8
            return decodeURIComponent(escape(text));
        } catch (e) {
            console.error("Error al corregir la codificación:", e);
            return text;  // Si hay error, devolvemos el texto original
        }
    }


    resetRecaptcha() {
        if (window.grecaptcha) {
            grecaptcha.reset();
        }
    }


    resetFormAndRecaptcha() {
        // Aseguramos que el estado del botón esté habilitado nuevamente para poder hacer otro intento
        this.isButtonVisible = true;
        this.isRecaptchaVisible = true;

        // Reseteamos el formulario
        this.form.reset();

        // Limpiamos el recaptcha token
        this.recaptchaToken = null;

        // Resetear el reCAPTCHA (esto asegura que se reinicie el proceso)
        if (window.grecaptcha) {
            grecaptcha.reset();
        }

        // Si usas un `formControlName` para reCAPTCHA, puedes deshabilitarlo nuevamente si es necesario
        this.form.controls['recaptcha'].setValue('');
        this.form.controls['recaptcha'].disable();
    }


    ingresoHome():void {
        this.alertService.showAlert('Inicio de sesión exitoso', 'success');
        this.failedAttempts = 0;
        this.recaptchaToken = null;
        this.router.navigate(['/inicio']);
    }


    //* INICIO SESION LOCAL */
    onSubmit(event: Event) {
        this.isButtonVisible = false;
        this.isRecaptchaVisible = false;

        if (this.form.valid && this.recaptchaToken) { //&& this.recaptchaToken
            const email = this.form.value.email;
            const password = this.form.value.password;
            const ecryptedPassword: string = password ? CryptoJS.MD5(password).toString() : '';
            const recaptchaToken = this.recaptchaToken;
            const secretKey = this.recaptchaSiteKey?.secret_key || '';

            const data: RegisterData | null = sessionStorage.getItem('data_register') ? JSON.parse(sessionStorage.getItem('data_register') || '') : null;
            if (data && data.correo === email) {
                // Aquí llamamos al servicio para validar si usuario ya está activado
                this.authService.checkUserActivated(email).subscribe(response => {
                    if (response.success) {
                        if (response.data?.registered) {
                            // Usuario ya registrado y activo, hacemos login normal y limpiamos sessionStorage
                            sessionStorage.removeItem('data_register');
                            sessionStorage.removeItem('token_register');
                            this.sendLogin(email, ecryptedPassword, recaptchaToken, secretKey);
                        } else {
                            // Usuario no está activado aún, seguimos con registro pendiente
                            this.verifCredentRegister(email, ecryptedPassword, data, recaptchaToken, secretKey);
                        }
                    } else {
                        // En caso de error o usuario no encontrado, hacemos login normal
                        this.sendLogin(email, ecryptedPassword, recaptchaToken, secretKey);
                    }
                });
            } else {
                this.sendLogin(email, ecryptedPassword, recaptchaToken, secretKey);
            }

            // Resetear reCAPTCHA
            this.resetRecaptcha();

        } else {
            console.error('Formulario inválido');
            this.alertService.showAlert('Credenciales de acceso incorrectas', 'error');

            // Resetear el formulario y reCAPTCHA al detectar un error
            this.resetFormAndRecaptcha();
        }
    }


    private getFriendlyErrorMessage(error: any): string {
        if (!navigator.onLine) {
            // Caso de desconexión
            return 'Conexión perdida. Por favor, verifique su conexión a internet.';
        }

        if (error.status) {
            switch (error.status) {
                case 0:
                    return 'No se pudo conectar al servidor. Intente más tarde.';
                case 400:
                    return 'Solicitud inválida. Por favor, revise los datos ingresados.';
                case 401:
                    return 'No autorizado. Por favor, inicie sesión nuevamente.';
                case 404:
                    return 'Servicio no encontrado. Intente más tarde.';
                case 500:
                    return 'Error interno del servidor. Por favor, intente más tarde.';
                default:
                    return 'Ocurrió un error inesperado. Intente de nuevo.';
            }
        }

        // Si no hay un código de estado, devuelve un mensaje genérico
        return 'Ocurrió un error inesperado. Intente de nuevo.';
    }


    /* ------------------------ Meth. Services ------------------------ */

    getInfoKeyCaptchaService() {
        this.keyRecaptchaServiceService.getKeyRecaptcha().subscribe({
            next: (data: InfoDataKeys) => {
                if (data && data.site_key) {
                    this.recaptchaSiteKey = data;

                    // Después de obtener las claves, carga los scripts
                    this.loadScript('https://www.google.com/recaptcha/api.js').then(() => {
                        return this.loadScript('https://accounts.google.com/gsi/client');
                    }).then(() => {
                        // Habilita el control de reCAPTCHA después de cargar los scripts
                        this.form.controls['recaptcha'].enable();
                        this.cdr.detectChanges();

                        // Inicializa Google Sign-in si es necesario
                        this.initGoogleSignin();
                    }).catch(error => {
                        console.error('Error al cargar los scripts:', error);
                    });

                } else {
                    console.warn('No se recibió una clave de reCAPTCHA válida.');
                }
            },
            error: (err: any) => {
                console.error('Error al obtener la clave de reCAPTCHA:', err);
            }
        });
    }


    verifCredentRegister(email: string, ecryptedPassword: string, data: RegisterData, recaptchaToken: string, secretKey: string) {
        const token_preRegister = sessionStorage.getItem('token_register');

        if (data.correo === email && data.contrasena_temp === ecryptedPassword) {

            this.registerUserService.postRegisterUser(data, token_preRegister).subscribe({
                next: response => {
                    if (response.success) {
                        sessionStorage.removeItem('data_register');
                        sessionStorage.removeItem('token_register');
                        console.warn('login registro');

                        Swal.fire({
                            title: '¡Éxito!',
                            text: 'Registro de cuenta exitoso, se procederá a iniciar sesión.',
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(() => {
                            this.sendLogin(email, data.contrasena_temp, recaptchaToken, secretKey);
                        });
                    } else {
                        Swal.fire({
                            title: response.message,
                            text: "¿Desea volver a enviar el correo de verificación?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#095540",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Si, volver a enviar",
                            cancelButtonText: "No, cancelar"
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.reEnviarCorreoVerificacion(email);
                            }
                        });
                        console.error('Error al registrar usuario: ', response.message);
                        this.alertService.showAlert('Error al registrar usuario: ' + response.message, 'error');
                        this.resetFormAndRecaptcha();
                    }
                },
                error: error => {
                    this.alertService.showAlert('Error al registrar usuario: ' + error.message, 'error');
                    this.resetFormAndRecaptcha();
                }
            });
            return;
        } else {
            Swal.fire({
                title: 'Contraseña inválida',
                text: 'Para completar el proceso de registro verifica la contraseña enviada a tu correo.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
            this.alertService.showAlert('Credenciales inválidas', 'error');
            this.resetFormAndRecaptcha();
        }
    }


    sendLogin(email: string, ecryptedPassword: string, recaptchaToken: string, secretKey: string) {
        Swal.fire({
            title: 'Cargando...',
            text: 'Estamos validando tus credenciales, por favor espera.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const domain = sessionStorage.getItem('domain') || '';

        this.authService.login2Web(email, ecryptedPassword, domain, recaptchaToken, secretKey).subscribe({
            next: (response) => {
                if (response.success == 1) {
                    Swal.fire({
                        title: '¡Éxito!',
                        text: 'Inicio de sesión exitoso. Redirigiendo...',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(() => {
                        this.ingresoHome();
                    });
                } else if (response.success == 2) {
                    Swal.fire({
                        title: 'Tu registro aún no ha sido completado',
                        text: response.message,
                        icon: 'info',
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: "#095540",
                    });
                    this.alertService.showAlert(response.message || 'Credenciales de pre-registro', 'info');
                    this.resetFormAndRecaptcha();
                } else if(response.success == 3) {
                    Swal.fire({
                        title: 'Contraseña de pre-registro incorrecta',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: "#095540",
                    });
                    this.alertService.showAlert(response.message || 'Contraseña de pre-registro incorrecta', 'warning');
                    this.resetFormAndRecaptcha();
                } else {
                    this.failedAttempts++;
                    if (this.failedAttempts >= this.maxFailedAttempts) {
                        Swal.fire({
                            title: 'Demasiados intentos fallidos',
                            text: '¿Deseas reestablecer tu contraseña?',
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#095540",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Si",
                            cancelButtonText: "No, cancelar"
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.router.navigate(['/restablecer-contrasena']);
                            }
                        });
                    } else {
                        Swal.fire({
                            title: 'Credenciales inválidas',
                            text: response.message,
                            icon: 'error', 
                            confirmButtonText: 'Aceptar',
                            confirmButtonColor: "#095540",
                        });
                        this.alertService.showAlert(response.message || 'Credenciales inválidas.', 'error');
                        this.resetFormAndRecaptcha();
                    }
                }
            },
            error: (error) => {
                const errorMessage = this.getFriendlyErrorMessage(error);
                Swal.fire({
                    title: 'Error de autenticación',
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
                this.alertService.showAlert('Error de autenticación: ' + errorMessage, 'error');
                this.resetFormAndRecaptcha();
            }
        });
    }


    requestPreRegisterUserData(userId: string) {
        this.registerUserService.getPreRegisterUserData(userId).subscribe({
            next: (response: PreRegisterResponseData) => {
                if (response.success) {
                    const userData: RegisterData = {
                        nombre: response.data?.nombre || '',
                        apellido: response.data?.apellido || '',
                        direccion: response.data?.direccion || '',
                        tipoDocIdent: response.data?.tipoDocIdent || '',
                        numDocIdent: response.data?.numDocIdent || '',
                        numTelefono: response.data?.numTelefono || '',
                        correo: response.data?.correo || '',
                        contrasena_temp: response.data?.contrasena_temp_md5 || ''
                    };

                    //this.sessionStorageDataService.saveData('data_register', userData);
                    sessionStorage.setItem('data_register', JSON.stringify(userData));
                    sessionStorage.setItem('token_register', response.data?.token || '');
                } else {
                    this.alertService.showAlert(response.message, 'error');
                    console.error('Error al obtener datos de pre-registro:', response.message);
                }
            },
            error: (error) => {
                console.error('Error al obtener los datos de pre-registro:', error);
                alert('Hubo un error al obtener los datos de pre-registro. Por favor, inténtalo de nuevo más tarde.');

            }
        })
    }


    reEnviarCorreoVerificacion(email: string) {
        this.registerUserService.reenviarCorreoVerificacion(email).subscribe({
            next: (response: ReEnvioCorreoTempResponseData) => {
                if (response.success) {
                    const data_register = JSON.parse(sessionStorage.getItem('data_register') || '{}');
                    if (data_register) {
                        // Actualizamos contrasena_temp
                        data_register.contrasena_temp = response.data?.codigo_temp_md5 || '';
                        // Guardamos los datos actualizados nuevamente en sessionStorage
                        sessionStorage.setItem('data_register', JSON.stringify(data_register));

                        // Actualizamos token_register en sessionStorage
                        if (response.data?.token) {
                            sessionStorage.setItem('token_register', response.data.token);
                        }
                    }

                    Swal.fire({
                        title: '¡Éxito!',
                        text: 'Correo de verificación reenviado.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.message,
                        icon: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            }
            , error: (error) => {
                console.error('Error al reenviar el correo de verificación:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo reenviar el correo de verificación. Intenta nuevamente más tarde.',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            }
        });
    }


    //* INICIO SESION CON GOOGLE */
    initGoogleSignin() {
        // Cerrar sesión de cualquier cuenta anterior
        // Verifica si el SDK de Google está disponible
        if (window.google && window.google.accounts) {
            window.google.accounts.id.disableAutoSelect();
            window.google.accounts.id.revoke();

            // Cargar el SDK de Google
            window.google.accounts.id.initialize({
                client_id: '257763739718-t6pn7kg5a4dmgk58aobuuma9qdvlld5i.apps.googleusercontent.com',
                callback: (response: any) => this.handleOauthResponse(response),
                scope: 'openid profile https://www.googleapis.com/auth/contacts.readonly',
            });

            // Renderizar el botón de Google Sign-In
            const googleSignInBtn = document.getElementById("google-signin-btn");
            if (googleSignInBtn) {
                window.google.accounts.id.renderButton(googleSignInBtn, {
                    theme: "outline",
                    size: "large",
                    shape: "pill",
                    text: "signin",
                    width: "256px",
                });
            } else {
                console.warn('No se encontró el botón de Google Sign-In en el DOM');
            }
            window.google.accounts.id.prompt();
        } else {
            console.error('El SDK de Google no está cargado.');
        }
    }


    // Método para decodificar el JWT Token
    decodeJWTToken(token: string): any {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            console.error('Error decoding JWT token', e);
            return null;
        }
    }

    // Método que maneja la respuesta del OAuth (se pasa como callback)
    handleOauthResponse(response: any): void {
        if (response && response.credential) {
            const responsePayload = this.decodeJWTToken(response.credential);
            if (responsePayload) {
                sessionStorage.setItem('loggedinUser', JSON.stringify(responsePayload));

                this.sendAccountGoogle();
            } else {
                console.error('Error al decodificar el JWT token');
            }
        } else {
            console.error('Error en la respuesta OAuth: Credential no disponible', response);
        }
    }


    sendAccountGoogle() {
        const userDatGoogle: userDataGoogle | null = JSON.parse(sessionStorage.getItem('loggedinUser') || 'null');
        if (userDatGoogle?.email_verified === true) {
            const givenNameCorregido = this.corregirCodificacion(userDatGoogle?.given_name ?? '');
            const familyNameCorregido = this.corregirCodificacion(userDatGoogle?.family_name ?? '');

            const ladata = {
                email: userDatGoogle.email,
                email_verified: userDatGoogle.email_verified,
                given_name: givenNameCorregido,
                family_name: familyNameCorregido,
            }

            Swal.fire({
                title: 'Cargando...',
                text: 'Estamos validando tu cuenta de Google, por favor espera.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const domain = sessionStorage.getItem('domain') || '';

            this.authService.loginOAuthGoogle(ladata, domain).subscribe({
                next: (response) => {
                    if (response.success) {
                        Swal.fire({
                            title: '¡Éxito!',
                            text: 'Inicio de sesión exitoso con Google. Redirigiendo...',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(() => {
                            sessionStorage.removeItem('loggedinUser');
                            this.ingresoHome();
                        });
                    } else {
                        this.failedAttempts++;
                        if (this.failedAttempts >= this.maxFailedAttempts) {
                        } else {
                            Swal.fire({
                                title: 'Error',
                                text: 'No se pudo iniciar sesión con Google. Intenta nuevamente.',
                                icon: 'error',
                                confirmButtonText: 'Aceptar'
                            });
                            this.alertService.showAlert(response.message || 'Error al registrar usuario.', 'error');
                        }
                        console.error('Error al registrar usuario: ', response.message);
                        this.alertService.showAlert('Error al registrar usuario: ' + response.message, 'error');
                    }
                },
                error: error => {
                    const errorMessage = this.getFriendlyErrorMessage(error);
                    Swal.fire({
                        title: 'Error de autenticación',
                        text: errorMessage,
                        icon: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                    this.alertService.showAlert('Error al registrar usuario: ' + errorMessage, 'error');
                }
            });
        }
    }

}


